/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import Layout from 'components/Layout';
import Button, { ButtonContainer } from 'components/Button';
import StepNavigation from 'components/StepNavigation'
import {
    FileModal, HasPermission
} from '@fitinsur/components';
import {
    Content,
    ButtonContent
} from './styles';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import { LoaderContext } from '@fitinsur/contexts';
import { useGetDocuments } from 'services/DocumentsService';
import { useGetOperation } from 'services/OperationService';
import { useSendDocuments } from '@fitinsur/services/DocumentsService';

export default function QuoteDocument({ match, permissions }) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const history = useHistory();
    const formikRef = useRef({});
    const handleBack = () => history.goBack();

    const [documents, setDocuments] = useState([])
    const [operation, setOperation] = useState();

    const {
        data: useGetDocumentsData,
        loading: useGetDocumentsLoading,
        error: useGetDocumentsError,
        status: useGetDocumentsStatus,
        request: useGetDocumentsRequest
    } = useGetDocuments(match.params?.idOperation);

    const {
        data: useGetOperationData,
        loading: useGetOperationLoading,
        error: useGetOperationError,
        status: useGetOperationStatus,
        request: useGetOperationRequest
    } = useGetOperation(match.params?.idOperation);   
      
    const {
        data: useSendDocumentsData,
        loading: useSendDocumentsLoading,
        error: useSendDocumentsError,
        status: useSendDocumentsStatus,
        request: useSendDocumentsRequest
    } = useSendDocuments(match.params?.idOperation);      

    useEffect(() => {
        useGetOperationRequest();
        useGetDocumentsRequest(null, { allDocs: true })
    }, []);

    useEffect(() => {
        updateIsLoadingStatus(useGetDocumentsLoading
            || useGetOperationLoading
            || useSendDocumentsLoading
        );
    }, [useGetDocumentsLoading,
        useGetOperationLoading,
        useSendDocumentsLoading
    ]);

    useEffect(() => {
        if (!useGetDocumentsStatus) return;
        if (useGetDocumentsStatus === 200) {
            const quoteDoc = useGetDocumentsData.value.find(v => [261].includes(v.idDomain));
            const proposalDoc = useGetDocumentsData.value.find(v => [324].includes(v.idDomain));
            const policyDoc = useGetDocumentsData.value.find(v => [728].includes(v.idDomain));
            const quoteRequestDocuments = [proposalDoc, policyDoc, quoteDoc].filter(v => v?.url || v?.reportToken);

            if (quoteRequestDocuments.length) {
                setDocuments(quoteRequestDocuments.map(quoteRequestDocument => ({
                    idDocument: quoteRequestDocument.idDocument,
                    idDomain: quoteRequestDocument.idDomain,
                    idDomainDescription: quoteRequestDocument.idDomainDescription,
                    idReport: quoteRequestDocument.idReport,
                    idOperation: quoteRequestDocument.idOperation,
                    reportToken: quoteRequestDocument.reportToken,
                    url: quoteRequestDocument.url,
                    fileName: quoteRequestDocument.documentMetadata.fileName
                })))
            }
        }
    }, [useGetDocumentsStatus]);

    useEffect(() => {
        if (!useGetOperationStatus) return;
        if (useGetOperationStatus === 200) {
          if (useGetOperationData.statusCode === 200) {
            setOperation(useGetOperationData.value);
          }
        }
    }, [useGetOperationStatus])    

    return (
        <Layout
            title={""}
            subtitle={match?.params?.idOperation}
            idOperation={match.params?.idOperation}
        >
            <Row>
                <Col>
                    <StepNavigation stage={2} idOperation={match.params?.idOperation} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <BrokingSummary
                        history={history}
                        idOperation={match?.params?.idOperation}
                        permissions={permissions}
                    />
                </Col>
            </Row>

            <Content>
                <Formik
                    innerRef={formikRef}
                    initialValues={{}}
                    enableReinitialize={true}
                >
                    {() => (
                        <Form>
                            <FileModal documents={documents} />

                            <ButtonContainer>
                                <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                                <ButtonContent>
                                <HasPermission permission={
                                    permissions.NBI_REQUEST_APPROVE_REJECT &&
                                    operation?.isRenewal &&
                                    documents?.find(doc => doc.idDomain === 728) &&
                                    [8, 10].includes(operation?.idDomainStatus)
                                    }>
                                        <Button
                                        id="btnSave"
                                        type="button"
                                        onClick={() => useSendDocumentsRequest({
                                            idDomainDocuments: [728],
                                            idDomainPersons : [10],
                                            subjectEmail: `Sompo Seguros - Segue a cotação ${operation.idOperation} - @person_name`,
                                            bodyEmail: `<p>Prezado @person_name,</p>
                                            <p>Segue em anexo o documento da minuta da cotação de Nº ${operation.idOperation} para sua análise.</p>
                                            <p>Para evoluir com a emissão é necessário que acesse o Portal do Corretor => Menu => Cotações => Localize a cotação e escolha a opção 'Contratar'.</p>
                                            <p>Atenciosamente.<br>Sompo Seguros S/A<br><a href='https://www.sompo.com.br'>www.sompo.com.br</a></p>
                                            `
                                        })}
                                        third
                                        >
                                        COMUNICAR CORRETOR
                                        </Button>
                                    </HasPermission>         
                                    &nbsp;                           
                                    <Button
                                        type="button"
                                        onClick={() => history.push(`/quote/plans-rcg/${match.params?.idProduct}/${match.params?.idOperation}`)}
                                        third
                                    >
                                        TELA DE PLANOS
                                    </Button>
                                </ButtonContent>
                            </ButtonContainer>
                        </Form>
                    )}
                </Formik>
            </Content>
        </Layout >
    )
}